import React from 'react';
import style from '../styles/componentStyle/fieldSettings/RequireIcon.scss';
/**
 * 必須アイコン
 *
 * @param {boolean} { isShow = true } 表示するかどうか(デフォルトは表示)
 * @returns
 */
const RequireIcon = ({
  isShow = true,
  isSpace = false,
  requiredText = '必須',
  cssClass = '',
}) => {
  return isShow ? (
    <span
      className={`${style['require_icon']} RequireIcon ${
        isSpace ? 'RequireIcon--space' : ''
      } ${cssClass}`}
    >
      {requiredText}
    </span>
  ) : null;
};

export default RequireIcon;



// WEBPACK FOOTER //
// ./src/components/RequireIcon.jsx